/**
 * @module hooks/useScrollReset
 * @category Hooks
 * @description Um hook que redefine a posição de rolagem para o topo da página ao mudar de rota.
 * @returns {null} Retorna null.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollReset = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default useScrollReset;
